import api from '@/data/fetchType.js';
/*
 * @Author: Junchi Zhao
 * @LastEditors: Please set LastEditors
 * @Description:
 */
function getList(params) {
  return new Promise((resolve, reject) => {
    api
      .formPost('/api/flow/task/getTasked', params)
      .then((res) => {
        resolve(res);
      })
      .catch((e) => {
        reject(e);
      });
  });
}

function deleteInstance(params) {
  return new Promise((resolve, reject) => {
    api
      .formPost('/api/flow/instance/doDelInstance', params)
      .then((res) => {
        resolve(res);
      })
      .catch((e) => {
        reject(e);
      });
  });
}

function getTaskTypeList(params) {
  return new Promise((resolve, reject) => {
    api
      .formPost('/api/flow/task/getTaskedType', params)
      .then((res) => {
        resolve(res);
      })
      .catch((e) => {
        reject(e);
      });
  });
}
function getCountTaskedByDefName(params) {
  return new Promise((resolve, reject) => {
    api
      .formPost('/api/flow/task/getCountTaskedByDefName', params)
      .then((res) => {
        resolve(res);
      })
      .catch((e) => {
        reject(e);
      });
  });
}
export { getList, deleteInstance, getTaskTypeList, getCountTaskedByDefName };
